/**
 * @generated SignedSource<<89553292792c04c7244286768963c38c>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstname",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastname",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserInvitationModalQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserInvitationModalQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "88f02056eb6eb8b4f60b72d2c3c390f7",
            "id": null,
            "metadata": {},
            "name": "UserInvitationModalQuery",
            "operationKind": "query",
            "text": "query UserInvitationModalQuery(\n  $userId: ID!\n) {\n  user(id: $userId) {\n    id\n    email\n    firstname\n    lastname\n  }\n}\n"
        }
    };
})();
node.hash = "daccf78a1991a945048d5a82d3968de9";
export default node;
